<template>
  <!-- 人员信息 -->
  <div class="edu_pages">
    <div class="edu_pages_content_top">
      <div class="edu_header_title">人员信息</div>
    </div>
    <div class="edu_pages_content">
      <div class="edu_pages_content_header">
        <div>
          <el-input
            style="width:200px;margin-left:5px"
            placeholder="请输入手机号"
            v-model.trim="listRequestData.userPhone"
            size="mini"
            clearable
          >
          </el-input>
          <el-input
            style="width:200px;margin-left:5px"
            placeholder="请输入用户名"
            v-model.trim="listRequestData.userName"
            size="mini"
            clearable
          >
          </el-input>
          <el-button
            style="margin-left:5px"
            type="primary"
            icon="el-icon-search"
            size="mini"
            plain
            @click="getDataList"
            >搜索</el-button
          >
          <el-button
            style="margin-left:10px"
            type="success"
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="openAddBox(1)"
            >新增</el-button
          >
        </div>
      </div>
      <div class="edu_pages_content_body">
        <el-table
          :data="dataList.list"
          height="100%"
          border
          style="width: 100%"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                dataList.pageSize * (dataList.pageNum - 1) + scope.$index + 1
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="loginId"
            label="登录账号"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="!scope.row.isEditJob"
                placement="top"
                effect="light"
              >
                <div slot="content">点击复制</div>
                <span
                  class="tag-read copy-span"
                  :data-clipboard-text="scope.row.loginId"
                  @click="clickCopy"
                  >{{ scope.row.loginId }}</span
                >
              </el-tooltip>
              <el-input
                v-else
                :maxlength="6"
                v-model.trim="scope.row.jobNumber"
                size="small"
                clearable
                placeholder="请输入工号（六位）"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="roleStatus"
            label="状态"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="rowData">
              {{ rowData.row.accountStatus == 0 ? "禁用" : "启用" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="450" align="center">
            <template slot-scope="rowData">
              <el-tooltip
                class="item"
                effect="dark"
                content="每天只能修改一次，请谨慎修改！"
                placement="top"
              >
                <el-button
                  v-show="rowData.row.isEditJob == false"
                  plain
                  @click="editJob(rowData.row)"
                  type="success"
                  size="mini"
                  icon="el-icon-circle-plus-outline"
                  >工号-编辑/添加</el-button
                >
              </el-tooltip>

              <el-button
                v-show="rowData.row.isEditJob == true"
                plain
                @click="addJob(rowData.row)"
                type="success"
                size="mini"
                title="仅支持六位工号"
                icon="el-icon-circle-plus-outline"
                :disabled="rowData.row.jobNumber.length != 6 ? true : false"
                >确认</el-button
              >
              <el-button
                v-show="rowData.row.isEditJob == true"
                plain
                @click="cencelJob()"
                type="warning"
                size="mini"
                icon="el-icon-circle-plus-outline"
                >取消</el-button
              >
              <el-button
                v-if="rowData.row.accountStatus == 0"
                plain
                @click="enableEduUser(rowData.row.userId)"
                type="success"
                size="mini"
                icon="el-icon-open"
                :disabled="rowData.row.isEditJob == true ? true : false"
                >启用</el-button
              >
              <el-button
                v-if="rowData.row.accountStatus == 1"
                plain
                @click="disableEduUser(rowData.row.userId)"
                type="danger"
                size="mini"
                icon="el-icon-turn-off"
                :disabled="rowData.row.isEditJob == true ? true : false"
                >禁用</el-button
              >
              <el-button
                type="warning"
                @click="editUserInfo(rowData.row.userId)"
                plain
                size="mini"
                icon="el-icon-edit"
                :disabled="rowData.row.isEditJob == true ? true : false"
                >编辑</el-button
              >
              <el-button
                :disabled="rowData.row.userId == userInfo.userId ? true : false || rowData.row.isEditJob == true ? true : false"
                type="danger"
                @click="delData(rowData.row)"
                plain
                size="mini"
                icon="el-icon-delete-solid"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="edu_pages_content_bottom" v-if="dataList.total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="dataList.pageNum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="listRequestData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dataList.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增角色 -->
    <el-dialog
      title="新增角色"
      :append-to-body="true"
      size="50%"
       width="800px"
      :before-close="handleClose"
      :visible.sync="actionDataBox"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      direction="ltr"
    >
      <div class="demo-drawer__content ">
        <form class="form-horizontal form_box">
          <div class="form-group">
            <label class="col-sm-2 control-label">用户名称</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                v-model.trim="actionDataInfo.userName"
                placeholder="用户名称（必填）"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">用户电话</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                v-model="actionDataInfo.userPhone"
                placeholder="用户电话（必填）"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">登录密码</label>
            <div class="col-sm-10">
              <el-input
                auto-complete="new-password"
                :placeholder="
                  infoStatus == 1
                    ? '请输入密码（必填）'
                    : '不填写密码为原密码（必填）'
                "
                style="border:1px solid #ccc;border-radius:4px"
                v-model.trim="actionDataInfo.userPwd"
                show-password
                size="small"
              ></el-input>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">身份证号</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                maxlength="18"
                v-model.trim="actionDataInfo.userIdNumber"
                placeholder="身份证号（非必填）"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">座机号</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                maxlength="24"
                v-model.trim="actionDataInfo.landlineNumber"
                placeholder="座机号（非必填）"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">邮箱地址</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                maxlength="56"
                v-model.trim="actionDataInfo.email"
                placeholder="邮箱地址（非必填）"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">性别选择</label>
            <div class="col-sm-10">
              <el-radio-group size="small" v-model="actionDataInfo.sex">
                <el-radio-button
                  v-for="typeList in $store.state.select.personnelSex"
                  :key="typeList.id"
                  :value="typeList.id"
                  :label="typeList.id"
                  >{{ typeList.nameOne }}</el-radio-button
                >
              </el-radio-group>
            </div>
          </div>
        </form>
      </div>
      <div class="demo-drawer__footer insert_data_button_box">
        <label class="col-sm-2 control-label"></label>
        <div class="col-sm-10">
          <el-button
            v-if="infoStatus == 1"
            type="primary"
            size="mini"
            @click="addDataInfo()"
            >提交</el-button
          >
          <el-button
            v-if="infoStatus == 2"
            type="primary"
            size="mini"
            @click="editDataAction()"
            >确定修改</el-button
          >
          <el-button @click="handleClose()" size="mini">返回</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      actionDataBox: false,
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        userPhone: "",
        userName: "",
        departmentId: ""
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },

      actionDataInfo: {
        userId: "",
        eduId: this.$store.getters.getEduData.eduId,
        roleId: 0,
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: 0,
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        officeLists: [{ positionId: 0 }]
      },
      infoStatus: 1
    };
  },
  watch: {},
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  methods: {
    openAddBox(cate) {
      this.infoStatus = cate;
      this.actionDataBox = true;
      if (cate == 1) {
        // 新增
        this.actionDataInfo = {
          userId: "",
          eduId: this.$store.getters.getEduData.eduId,
          roleId: 0,
          userName: "",
          userPhone: "",
          userPwd: "",
          departmentId: 0,
          userIdNumber: "",
          landlineNumber: "",
          email: "",
          sex: 0,
          officeLists: [{ positionId: 0 }]
        };
      }
    },
    cancelForm() {
      this.actionDataBox = false;
    },
    handleClose() {
      this.actionDataBox = false;
    },

    editBoxColse() {
      this.editBox = false;
    },
    handleSizeChange(val) {
      this.listRequestData.pageNum = 1;
      this.listRequestData.pageSize = val;
      console.log(`每页 ${val} 条`);
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    async editUserInfo(id) {
      var requestData = {
        userId: id
      };

      let res = await this.$Http.getEduUserDetails(requestData);

      if (res.code == 200) {
        console.log(res.data);
        this.actionDataInfo.userId = res.data.userId;
        this.actionDataInfo.roleId = res.data.roleId;
        this.actionDataInfo.userName = res.data.userName;
        this.actionDataInfo.userPhone = res.data.userPhone;
        this.actionDataInfo.userPwd = "";
        this.actionDataInfo.departmentId = res.data.departmentId;
        this.actionDataInfo.userIdNumber = res.data.userIdNumber;
        this.actionDataInfo.landlineNumber = res.data.landlineNumber;
        this.actionDataInfo.email = res.data.email;
        this.actionDataInfo.sex = res.data.sex;
        this.openAddBox(2);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    editJob(row) {
      row.isEditJob = true;
      // 一次只修改一条
      // let data = this.dataList.list
      // this.dataList.list = data.map((item,index)=>{
      //     item.isEditJob = row.userId == item.userId ? true :false
      //     return item
      // })
    },
    async addJob(row) {
      let req = {
        jobNumber: row.jobNumber,
        userId: row.userId
      };
      let res = await this.$Http.addJobNumber(req, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage || "添加成功",
          type: "success"
        });
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage || "添加失败",
          type: "error"
        });
      }
    },
    cencelJob() {
      this.getDataList();
    },
    async getDataList() {
      let req = Object.assign({}, this.listRequestData, {
        eduBuresuType: -2
      });
      let res = await this.$Http.getEduUserList(req);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        // this.dataList.list = res.data.list;
        let list = res.data.list || [];
        this.dataList.list = list.map((item, index) => {
          item.isEditJob = false;
          item.jobNumber = item.loginId;
          return item;
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async addDataInfo() {
      this.actionDataInfo.eduBuresuType = -2;
      if (
        !this.actionDataInfo.userName ||
        !this.actionDataInfo.userPhone ||
        !this.actionDataInfo.userPwd
      ) {
        this.$message({
          message: "请填写完整信息",
          type: "warning"
        });
        return;
      }
      var requestData = JSON.parse(JSON.stringify(this.actionDataInfo));
      delete requestData.userId;
      let res = await this.$Http.addEduUser(requestData);
      console.log(JSON.stringify(this.actionDataInfo));
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.cancelForm();
        this.actionDataInfo.roleId = 0;
        this.actionDataInfo.userName = "";
        this.actionDataInfo.userPhone = "";
        this.actionDataInfo.userPwd = "";
        this.actionDataInfo.departmentId = 0;
        this.actionDataInfo.userIdNumber = "";
        this.actionDataInfo.landlineNumber = "";
        this.actionDataInfo.email = "";
        this.actionDataInfo.sex = 0;
        this.actionDataInfo.officeLists = [{ positionId: 0 }];
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async editDataAction() {
      this.actionDataInfo.eduBuresuType = -2;
      if (!this.actionDataInfo.userName || !this.actionDataInfo.userPhone) {
        this.$message({
          message: "请填写完整信息",
          type: "warning"
        });
        return;
      }
      var requestData = JSON.parse(JSON.stringify(this.actionDataInfo));
      let res = await this.$Http.addEduUser(requestData);
      console.log(JSON.stringify(this.actionDataInfo));
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.cancelForm();
        this.actionDataInfo.userId = "";
        this.actionDataInfo.roleId = 0;
        this.actionDataInfo.userName = "";
        this.actionDataInfo.userPhone = "";
        this.actionDataInfo.userPwd = "";
        this.actionDataInfo.departmentId = 0;
        this.actionDataInfo.userIdNumber = "";
        this.actionDataInfo.landlineNumber = "";
        this.actionDataInfo.email = "";
        this.actionDataInfo.sex = 0;
        this.actionDataInfo.officeLists = [{ positionId: 0 }];
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 禁用
    disableEduUser(dataId) {
      this.$confirm("确定要禁用此用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: [dataId]
          };
          let res = await this.$Http.disableEduUser(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    // 启用
    enableEduUser(dataId) {
      this.$confirm("确定要启用此用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: [dataId]
          };
          let res = await this.$Http.enableEduUser(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    // 删除数据
    delData(row) {
      this.$confirm("确定要删除吗？删除后的用户将无法恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: row.userId,
            loginId: row.loginId
          };
          let res = await this.$Http.delCollegeUser(requestData, true);
          console.log("高校删除用户");

          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped>
input::-webkit-input-placeholder {
  color: #c0c4cc;
}
input::-moz-input-placeholder {
  color: #c0c4cc;
}
input::-ms-input-placeholder {
  color: #c0c4cc;
}
</style>
